const hierarchyTreesBoiler = {
    stateHierarchyTree: {
        states: [
            {
                profitCenters: [
                    {
                        profitCenter: {
                            ProfitCenterID: -1,
                            ProfitCenterShortDesc: "",
                            ProfitCenterLongDesc: "",
                            StateID: -1,
                        },
                        serviceAreas: [
                            {
                                ServiceAreaID: -1,
                                ProfitCenterID: -1,
                                ServiceAreaShortDesc: "",
                                ServiceAreaLongDesc: "",
                            }
                        ]
                    },
                ],
                state: {
                    StateID: -1,
                    StateCode: "",
                    StateName: ""
                }
            },
        ]
    },
    profitCenterHierarchyTree: {
        profitCenters: [
            {
                profitCenter: {
                    ProfitCenterID: -1,
                    ProfitCenterShortDesc: "",
                    ProfitCenterLongDesc: "",
                    StateID: -1,
                },
                serviceAreas: [
                    {
                        ServiceAreaID: -1,
                        ProfitCenterID: -1,
                        ServiceAreaShortDesc: "",
                        ServiceAreaLongDesc: "",
                    }
                ]
            }
        ]
    }
}

export default hierarchyTreesBoiler